export const MAX_SLIPPAGE = 50;
export const MIN_SLIPPAGE = 0.1;

const DEFAULT_SLIPPAGE = 0.1;

export default DEFAULT_SLIPPAGE;
